import tr from './locales/tr';
import en from './locales/en';

export default {
  tr,
  en,
};
